<div class="videoWrapper">
    <iframe [src]="url" frameborder="0" allowfullscreen></iframe>
</div>